export class OrderDetail {
  public id?: string;
  public note?: string;
  public isFirstInstallation?: boolean;
}
